// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__162JT","title":"InfoRow_title__f585Y"};